import React from 'react';

const CustomInput = ({ search = false,...rest }) => {

  return (
    <form style={{padding: 0}} className="app-search d-lg-block">
        <div className="position-relative">
            <input
                type="text"
                className="form-control"
                {...rest}
            />
            {search && <span className="bx bx-search-alt" />}
        </div>
    </form>
  );
};

export default CustomInput;
